import { all, fork } from 'redux-saga/effects'

// App
import AppSagas from './app/sagas'
import ApiSagas from './api/sagas'
import RecipeSagas from './recipe/sagas'
import RecipesSagas from './recipes/sagas'
import RecipesByTagSagas from './recipesbytag/sagas'
import OnboardingSagas from './onboarding/sagas'
import I18nSagas from './i18n/sagas'
import UserSagas from './user/sagas'
import SwitchCourseSagas from './switchcourse/sagas'
import QuizzSagas from './quizz/sagas'
import QuizzResultsSagas from './quizzresults/sagas'
import QuizzResultSagas from './quizzresult/sagas'
import QuizzLandingSagas from './quizzlanding/sagas'
import EventLandingSagas from './eventlanding/sagas'
import EventDetailSagas from './eventdetail/sagas'
import PlanningSagas from './planning/sagas'
import PlanSagas from './plan/sagas'
import PlanningHistorySagas from './planninghistory/sagas'
import ShoppingListSagas from './shoppinglist/sagas'
import EarlierPlanningSagas from './earlierplanning/sagas'

function* loop() {
  yield all([
    ApiSagas.loop(),
    AppSagas.loop(),
    RecipeSagas.loop(),
    RecipesSagas.loop(),
    RecipesByTagSagas.loop(),
    SwitchCourseSagas.loop(),
    OnboardingSagas.loop(),
    I18nSagas.loop(),
    UserSagas.loop(),
    QuizzSagas.loop(),
    QuizzResultsSagas.loop(),
    QuizzResultSagas.loop(),
    QuizzLandingSagas.loop(),
    EventLandingSagas.loop(),
    EventDetailSagas.loop(),
    PlanningSagas.loop(),
    PlanningHistorySagas.loop(),
    PlanSagas.loop(),
    ShoppingListSagas.loop(),
    EarlierPlanningSagas.loop(),
  ])
}

export default function* rootSaga() {
  yield fork(loop)
}
